module.exports = __webpack_public_path__ + "assets/mam3.jpg?3e81cce8ce437da0858ba9d8e69fbd01";